/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel-layer surface for the scroll helper.
 *
 * `scrollIntoView` is a DOM utility that lives in the model layer, but views
 * must not reach into `src/model/**` directly (MVVM: model → viewModel →
 * views, enforced by scripts/lint-mvvm.cjs). This module is the sanctioned
 * path — a module of its own rather than a line in the `viewModel/utility`
 * barrel, so a component that only needs to scroll does not also pull in the
 * carousel and preview helpers that barrel carries.
 */
export { scrollIntoView } from "../../model/utility/scrollIntoView";
export type {
  IScrollIntoViewOptions,
  TScrollBlock
} from "../../model/utility/scrollIntoView";
